"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.handleKeyUpKeyboardKeys = exports.handleKeyDownKeyboardKeys = void 0;

var _options = require("../components/Options/helpers/options");

var _useListBox = _interopRequireDefault(require("../useListBox"));

var handleKeyDownKeyboardKeys = function handleKeyDownKeyboardKeys(_ref) {
  var state = _ref.state,
      dispatch = _ref.dispatch,
      onChangeContext = _ref.onChangeContext;
  return function (event) {
    // only prevent space events from scrolling page when in 'options view'
    if (event.key === " " && event.target.getAttribute("data-pka-anchor") !== "list-filter-input") {
      event.preventDefault();
    }

    if (["ArrowUp", "ArrowDown"].includes(event.key)) {
      (0, _options.handleArrowKeys)({
        event: event,
        state: state,
        dispatch: dispatch,
        onChangeContext: onChangeContext
      });
    }
  };
};

exports.handleKeyDownKeyboardKeys = handleKeyDownKeyboardKeys;

var handleKeyUpKeyboardKeys = function handleKeyUpKeyboardKeys(_ref2) {
  var providedProps = _ref2.providedProps,
      state = _ref2.state,
      dispatch = _ref2.dispatch,
      onChangeContext = _ref2.onChangeContext;
  return function (event) {
    if (providedProps.isDisabled) return;

    switch (event.key) {
      case "Escape":
        if (!state.isOpen) break;

        if (state.hasFooter) {
          dispatch({
            type: _useListBox["default"].types.cancel
          });
        } else {
          dispatch({
            type: _useListBox["default"].types.closePopover
          });
        }

        break;

      case "Enter":
      case " ":
        if (providedProps.isDisabled) return;
        (0, _options.handleEnterOrSpace)({
          event: event,
          providedProps: providedProps,
          state: state,
          dispatch: dispatch,
          onChangeContext: onChangeContext
        });
        break;

      default:
        break;
    }
  };
};

exports.handleKeyUpKeyboardKeys = handleKeyUpKeyboardKeys;
//# sourceMappingURL=handleKeyboardKeys.js.map